import { render, staticRenderFns } from "./LogItem.vue?vue&type=template&id=5abdf932"
import script from "./LogItem.vue?vue&type=script&lang=js"
export * from "./LogItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports